import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { CommonResponseModel, JobWorkAgainstUnitDto } from '@project-management-system/shared-models';
import { Repository } from 'typeorm';
import { ErrorResponse } from 'packages/libs/backend-utils/src/models/global-res-object';
import { JobWorkApproverDto } from './jobwork-approver-dto';
import { JobWorkAgainstUnitEntity } from './job-work-approval-entity';

@Injectable()
export class JobworkAgainstUnitService {
    constructor(
        @InjectRepository(JobWorkAgainstUnitEntity)
        private jobworkAgainstUintRepository: Repository<JobWorkAgainstUnitEntity>,
    ) { }


    async createJobWorkAgainstUnit(req: JobWorkAgainstUnitDto): Promise<CommonResponseModel> {
        try {

            const entity = new JobWorkAgainstUnitEntity();
            entity.name = req.name;
            entity.unitName = req.unitName;
            entity.approver = req.approver;
            entity.orderNo = req.orderNo;
            entity.createdUser = req.createdUser;
            entity.isActive = req.isActive;
            entity.versionFlag = req.versionFlag;
            entity.updatedUser = req.updatedUser;

            const save = await this.jobworkAgainstUintRepository.save(entity);

            if (!save) {
                return new CommonResponseModel(false, 0, 'Something went wrong in Job Work creation', []);
            } else {
                return new CommonResponseModel(true, 1, 'Created successfully', save);
            }

        } catch (err) {
            throw err;
        }
    }



    async getAllData(): Promise<CommonResponseModel> {
        const data = await this.jobworkAgainstUintRepository.find();
        if (data) {
          return new CommonResponseModel(true, 1, "Data Retrived", data);
        } else {
          return new CommonResponseModel(false, 0, "Data Retrived");
        }
      }

      async updateJobWorkApproval(req: JobWorkAgainstUnitDto): Promise<CommonResponseModel> {
        try {
            const updateResult = await this.jobworkAgainstUintRepository.update(
                { id: req.id },
                {
                    name: req.name,
                    unitName: req.unitName,
                    approver: req.approver,
                    orderNo: req.orderNo,
                }
            )

            if (updateResult.affected > 0) {
                return new CommonResponseModel(true, 11, 'Updated successfully', updateResult);
            } else {
                return new CommonResponseModel(false, 11, 'Update failed', []);
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async activateOrDeactivateJobWorkApproval(req: JobWorkAgainstUnitDto): Promise<CommonResponseModel> {
        try {
            console.log(req.isActive, 'service-----------')
            const Exists = await this.jobworkAgainstUintRepository.findOne({ where: { id: req.id } });
            if (Exists) {
                if (!Exists) {
                    throw new ErrorResponse(10113, 'Someone updated the current Data information.Refresh and try again');
                } else {

                    const update = await this.jobworkAgainstUintRepository.update(
                        { id: req.id },
                        { isActive: req.isActive, updatedUser: req.updatedUser });
                    if (Exists.isActive) {
                        if (update.affected) {
                            const Response: CommonResponseModel = new CommonResponseModel(true, 10115, 'Job Work Approval is Deactivated successfully');
                            return Response;
                        } else {
                            throw new CommonResponseModel(false, 10111, 'Job Work Approval is already deactivated');
                        }
                    } else {
                        if (update.affected) {
                            const Response: CommonResponseModel = new CommonResponseModel(true, 10114, 'Job Work Approval is activated successfully');
                            return Response;
                        } else {
                            throw new CommonResponseModel(false, 10112, 'Job Work Approval is already  activated');
                        }
                    }

                }
            } else {
                throw new CommonResponseModel(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }


}
